import React from 'react';
import ProtectedRoute from '../../components/ProtectedRoute/ProtectedRoute';
import QuizPage from '../../features/quiz/components/QuizPage';

const QuizPageRoute = () => {
  return (
    <ProtectedRoute requiresAuth={true}>
      <QuizPage />
    </ProtectedRoute>
  );
};

export default QuizPageRoute;